module.exports = __webpack_public_path__ + "img/tagRota.065b075f.png";